import axios from "~/plugins/axios";
import { DateFormatEnum } from "../enums";

const moment = require("moment");

export default {
  getById(externalPersonPropertyId, includes = []) {
    return axios.get(`/web_api/v1/external_person_property/${externalPersonPropertyId}`, {
      params: {
        include: includes,
      },
    }).then((response) => response.data);
  },
  create(externalPersonProperty) {
    return axios.post("/web_api/v1/external_person_property", externalPersonProperty).then((response) => response.data);
  },
  createAsCurrent(externalPersonProperty) {
    return axios.post("/web_api/v1/external_person_property/current", externalPersonProperty).then((response) => response.data);
  },
  update(externalPersonProperty) {
    const data = { ...externalPersonProperty };

    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of Object.entries(data)) {
      if (moment.isMoment(value)) {
        data[key] = value.format(DateFormatEnum.ISO8601);
      }
    }

    return axios.put(`/web_api/v1/external_person_property/${externalPersonProperty.id}`, data).then((response) => response.data);
  },
  findCurrentByExternalPersonAndAddressType(externalPersonId, addressType, includes = []) {
    return axios.post("/web_api/v1/external_person_property/current_by_external_person_and_address_type", {
      external_person_id: externalPersonId,
      address_type: addressType,
    }, { params: { include: includes } }).then((response) => response.data);
  },
  findOrCreateCurrentByExternalPersonAndPropertyAndAddressType(
    externalPersonId,
    propertyId,
    addressType,
  ) {
    return axios.post("/web_api/v1/external_person_property/find_or_create_current_by_external_person_and_property_and_address_type", {
      external_person_id: externalPersonId,
      property_id: propertyId,
      address_type: addressType,
    }).then((response) => response.data);
  },
  delete(externalPersonPropertyId) {
    return axios.delete(`/web_api/v1/external_person_property/${externalPersonPropertyId}`).then((response) => response.data);
  },
};
